import Polygon from './polygon';
import { getMillSizeFromThickness } from '@/plugins/emarf';

export default class Bin extends Polygon {

  constructor (id, width, depth, clearance = 0) {
    const points = [
      new THREE.Vector2(0, 0),
      new THREE.Vector2(width, 0),
      new THREE.Vector2(width, depth),
      new THREE.Vector2(0, depth)
    ];

    super(points, {
      closed: true
    });

    this.id = id;
    this.width = width;
    this.depth = depth;
    this.clearance = clearance;
    this.rulerTexts = [];

    this.element.classList.add('bin');

    {
      // offset
      const hc = clearance * 0.5;
      this.offsetOutlinePoints = [
        new THREE.Vector2(clearance, clearance),
        new THREE.Vector2(width - clearance, clearance),
        new THREE.Vector2(width - clearance, depth - clearance),
        new THREE.Vector2(clearance, depth - clearance)
      ];
      this.offsetFillPoints = [
        new THREE.Vector2(hc, hc),
        new THREE.Vector2(width - hc, hc),
        new THREE.Vector2(width - hc, depth - hc),
        new THREE.Vector2(hc, depth - hc)
      ];

      this.offsetOutline = this.createPolylineSVG({
        strokeColor: '#333',
        strokeWidth: 1
      });
      this.offsetOutline.classList.add('clearance-outline');

      this.offsetFill = this.createPolylineSVG({
        strokeWidth: clearance
      });
      this.offsetFill.classList.add('clearance-fill');

      this.element.appendChild(this.offsetOutline);
      this.element.appendChild(this.offsetFill);
    }
  }

  update () {
    super.update();
    this.updatePolyline(this.offsetOutline, this.offsetOutlinePoints);
    this.updatePolyline(this.offsetFill, this.offsetFillPoints);

    // if (this.referenceLineClearance) {
    //   this.updatePolyline(
    //     this.referenceLineClearance,
    //     this.referenceLineClearancePoints
    //   );
    // }

    // if (this.referenceLineVer) {
    //   this.updatePolyline(
    //     this.referenceLineVer,
    //     this.referenceLineVerPoints
    //   );
    // }

    // this.rulerTexts.forEach((text, i) => {
    //   console.log(text);
    //   let point = new THREE.Vector2(text.x, text.y);
    //   let center = new THREE.Vector2(0, 0);
    //   this.updateText(text, point, center);
    // });
  }

  addRulers () {
    const interval = 100;

    // y dir
    this.createRuler(
      this.points[3].clone().add(this.position),
      this.points[0].clone().add(this.position),
      0, interval
    );

    // x dir
    this.createRuler(
      this.points[3].clone().add(this.position),
      this.points[2].clone().add(this.position),
      1, interval, true
    );

    // y dir
    // this.createRuler(
    //   this.points[3].clone(), //.add(this.position),
    //   this.points[0].clone(), //.add(this.position),
    //   0,
    //   interval
    // );
    //
    // // x dir
    // this.createRuler(
    //   this.points[3].clone(), //.add(this.position),
    //   this.points[2].clone(), //.add(this.position),
    //   1,
    //   interval,
    //   true
    // );
  }

  addReferenceLine (width, depth, x, y, binClearance, binThickness) {
    const millSize = getMillSizeFromThickness(binThickness);
    const buffer = 1.5 * millSize + binClearance + 10;
    const bufferColor = "#808080";
    const dashDistance = "5";

    // make buffer area for vertical reference line
    {
      const px = x + (width / 2) - (buffer / 2);
      const points = `${px},${y + binClearance} ${px},${y + depth - binClearance}`;
      let clearance = this.createPolylineSVG({});
      clearance.setAttribute("stroke", bufferColor);
      clearance.setAttribute("stroke-opacity", "0.2");
      clearance.setAttribute("points", points);
      clearance.setAttribute("stroke-width", buffer);
      clearance.classList.add('referenceLine');
      this.element.appendChild(clearance);
    }

    // make vertical reference line
    {
      const px = x + (width / 2);
      const points = `${px},${y + binClearance} ${px},${y + depth - binClearance}`;
      let ver = this.createPolylineSVG({});
      ver.setAttribute("points", points);
      ver.setAttribute("stroke-dasharray", dashDistance);
      ver.classList.add("referenceLine");
      this.element.appendChild(ver);
    }

    // make horizontal reference line
    // let hor = this.createPolylineSVG({});
    // hor.setAttribute("points", `${x},${y+depth/2} ${x+width},${y+depth/2}`);
    // hor.setAttribute("stroke-dasharray", dashDistance);
    // this.element.appendChild(hor);
  }

  createRuler (from, to, direction = 0, interval = 100, skip = false) {
    const dir = (new THREE.Vector2()).subVectors(to, from);
    const len = dir.length();
    const ndir = dir.clone().normalize();

    const ox = (1 - direction) * 10;
    const oy = direction * 10;
    const offset = new THREE.Vector2(ox, oy);

    const n = len / interval;
    const xAxis = (direction === 1);
    const opy = (xAxis) ? 20 : 0;

    for (let i = 0; i < n; i++) {
      if (i <= 0 && skip) continue;

      let value = 0;
      if (i < n - 1) {
        value = i * interval;
      } else {
        value = len;
      }
      const p = from.clone().add(ndir.clone().multiplyScalar(value));
      p.sub(offset);

      let text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      text.classList.add(`direction-${direction}`);
      text.classList.add('rulerText');
      text.setAttributeNS(null, 'x', p.x);
      text.setAttributeNS(null, 'y', p.y + opy);
      if (xAxis) {
        text.setAttribute('transform', `rotate(90, ${p.x}, ${p.y + opy})`);
      }
      let textNode = document.createTextNode(value.toString());
      text.appendChild(textNode);
      this.element.appendChild(text);
      this.rulerTexts.push(text);
    }
  }

  containsPart (part) {
    // bin 内に部材が入っているかどうかをチェックする
    // nesting 側からもらった部材の位置がずらっしている場合があるため　tolerance 追加
    const eps = 1 // tolerance 追加
    const points = part.transform(part.offsetCheckPoints); // offsetPoints から offsetCheckPoints　変更
    const x0 = this.position.x + this.clearance - eps;
    const y0 = this.position.y + this.clearance - eps;
    const x1 = this.position.x + this.width - this.clearance + eps;
    const y1 = this.position.y + this.depth - this.clearance + eps;
    const found = points.find(p => {
      return (p.x < x0 || x1 < p.x) || (p.y < y0 || y1 < p.y);
    });
    return (found === undefined);
  }

  serialize () {
    return {
      id: this.id,
      width: this.width,
      depth: this.depth
    };
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/nesting/bin.js